import { render, staticRenderFns } from "./GroupReportRecipientsEdit.vue?vue&type=template&id=03f3ceff&scoped=true&"
import script from "./GroupReportRecipientsEdit.vue?vue&type=script&lang=js&"
export * from "./GroupReportRecipientsEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupReportRecipientsEdit.vue?vue&type=style&index=0&id=03f3ceff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3ceff",
  null
  
)

export default component.exports